(function (root, factory) {
  var api = factory(typeof module === "object" && module.exports
    ? require("./bb-review-approvals.js") : root.BadgeBuzzReviewApprovals);
  if (typeof module === "object" && module.exports) module.exports = api;
  if (root) root.BadgeBuzzProductDesignController = api;
})(typeof window !== "undefined" ? window : globalThis, function (ReviewApprovals) {
  "use strict";

  var TOKEN_ENDPOINT = "/apps/bb-portal/zakeke-token";
  var CUSTOMIZER_ENDPOINT = "https://api.zakeke.com/v1/iframe";
  var IFRAME_ORIGINS = [
    "https://customizer-worker.zakeke.com",
    "https://portal.zakeke.com",
  ];
  var MSG_ADD_TO_CART = [0, 2, 8];
  var MSG_DESIGN_CHANGE = 1;
  var MSG_SAVE_DESIGN = "SaveDesign";

  // Review-only placement preview. Geometry follows the badge front faces
  // and Custom Lanyard PDFs on /pages/templates (7-Sep live backup).
  // This is approximate placement, never an artwork transform or print proof.
  function placementTemplate(handle, configuration, properties) {
    configuration = configuration || {};
    properties = properties || {};
    function value(key) { return String(configuration[key] || properties[key] || '').trim(); }
    var size = value('Size').replace(/\s/g, '').replace('×', 'x');
    var slots = value('Perforated Slots').toLowerCase();
    var sizes = {
      'paper-name-badge': ['4x3', '4x6'],
      'tear-resistant-name-badge': ['4x3', '4x6'],
      'intellibadge-name-badge': ['4x3', '4x6'],
      'butterfly-name-badge': ['3.8x3.2', '3.8x5.3'],
      'plastic-name-badge': ['3.74x5.31', '4.33x6.3'],
    };
    if (sizes[handle] && sizes[handle].indexOf(size) !== -1) {
      var paper = handle === 'paper-name-badge';
      var plastic = handle === 'plastic-name-badge';
      var butterfly = handle === 'butterfly-name-badge';
      if (paper && slots && slots !== 'none') return null;
      if (plastic && (['one', 'two'].indexOf(slots) === -1 || /^yes$/i.test(value('Clear pouch')) || /^yes$/i.test(value('Clear front pouch')))) return null;
      if (!paper && !plastic && slots && slots !== 'three') return null;
      var dimensions = size.split('x');
      return {width: Math.round(Number(dimensions[0]) * 100), height: Math.round(Number(dimensions[1]) * 100),
        label: dimensions.join(' × ') + ' in', noun: 'badge',
        corners: paper ? 0 : plastic ? 8 : butterfly ? 15 : 12.5,
        slots: paper ? 0 : plastic ? (slots === 'one' ? 1 : 2) : 3,
        slotStyle: plastic ? 'plastic' : butterfly ? 'butterfly' : 'triple'};
    }
    if (['bulldog-metal-clip-lanyards', 'metal-hook-lanyards', 'plastic-hook-lanyards'].indexOf(handle) !== -1) {
      if ((configuration.Customization || properties.Customization) === 'Solid Color') return null;
      var width = String(configuration.Width || properties.Width || '').trim().replace(/[″”]/g, '"');
      var inches = {'3/8"': 0.375, '1/2"': 0.5, '5/8"': 0.625, '3/4"': 0.75, '1"': 1}[width];
      // PDF trim rectangles are 2592pt (36in) long, with widths 27–72pt.
      return inches ? {width: 3600, height: inches * 100, label: 'Flat strip · 36 in × ' + width, noun: 'lanyard', strip: true} : null;
    }
    return null;
  }

  function placementShape(template) {
    var w = template.width, h = template.height, r = template.corners || 0;
    var shape = r ? 'M' + r + ' 0H' + (w-r) + 'Q' + w + ' 0 ' + w + ' ' + r + 'V' + (h-r) + 'Q' + w + ' ' + h + ' ' + (w-r) + ' ' + h + 'H' + r + 'Q0 ' + h + ' 0 ' + (h-r) + 'V' + r + 'Q0 0 ' + r + ' 0Z' : 'M0 0H' + w + 'V' + h + 'H0Z';
    function slot(x, y, width, height, arch) {
      var radius = height / 2, left = x + radius, right = x + width - radius, middle = x + width / 2;
      var top = arch ? 'H' + (middle-12) + 'Q' + (middle-10) + ' ' + y + ' ' + (middle-9) + ' ' + (y-4) + 'Q' + (middle-7) + ' ' + (y-9.4) + ' ' + middle + ' ' + (y-9.4) + 'Q' + (middle+7) + ' ' + (y-9.4) + ' ' + (middle+9) + ' ' + (y-4) + 'Q' + (middle+10) + ' ' + y + ' ' + (middle+12) + ' ' + y : '';
      return ' M' + left + ' ' + y + top + 'H' + right + 'A' + radius + ' ' + radius + ' 0 0 1 ' + right + ' ' + (y+height) + 'H' + left + 'A' + radius + ' ' + radius + ' 0 0 1 ' + left + ' ' + y + 'Z';
    }
    if (template.slots === 1) shape += slot(w/2-31.25, 20, 62.5, 15.6, false);
    if (template.slots === 2) shape += slot(28, 20, 62.5, 15.6, false) + slot(w-90.5, 20, 62.5, 15.6, false);
    if (template.slots === 3) {
      var butterfly = template.slotStyle === 'butterfly';
      var inset = butterfly ? 25.5 : 37.5, width = butterfly ? 56 : 62.5;
      var y = butterfly ? 27 : 25, height = butterfly ? 14.5 : 12.5;
      shape += slot(inset, y, width, height, false) + slot(w/2-width/2, y, width, height, true) + slot(w-inset-width, y, width, height, false);
    }
    return shape;
  }

  function showPlacementPreview(review, original, url, template) {
    var doc = review.ownerDocument;
    var figure = doc.createElement("figure");
    figure.className = "bb-review__placement";
    figure.setAttribute("data-bb-upload-placement", "");
    var ns = "http://www.w3.org/2000/svg";
    function svgNode(name, attrs, parent) {
      var node = doc.createElementNS(ns, name);
      Object.keys(attrs).forEach(function (key) { node.setAttribute(key, attrs[key]); });
      parent.appendChild(node);
      return node;
    }
    var w = template.width;
    var h = template.height;
    var svg = svgNode("svg", {viewBox: "0 0 " + w + " " + h, role: "img", "aria-label": "Your uploaded artwork fitted to the " + template.label + " " + template.noun}, figure);
    var shape = placementShape(template);
    var defs = svgNode("defs", {}, svg);
    var clip = svgNode("clipPath", {id: "bb-upload-placement-clip"}, defs);
    svgNode("path", {d: shape, "clip-rule": "evenodd"}, clip);
    var artwork = svgNode("g", {"clip-path": "url(#bb-upload-placement-clip)"}, svg);
    svgNode("rect", {width: w, height: h, fill: "white"}, artwork);
    svgNode("image", {href: url, width: w, height: h, preserveAspectRatio: "xMidYMid meet"}, artwork);
    svgNode("path", {d: shape, fill: "none", stroke: "currentColor", "stroke-width": "0.65", "vector-effect": "non-scaling-stroke"}, svg);
    if (template.strip) {
      var detail = doc.createElement('div');
      detail.className = 'bb-review__strip-detail';
      detail.tabIndex = 0;
      detail.setAttribute('role', 'region');
      detail.setAttribute('aria-label', 'Enlarged lanyard strip; scroll horizontally to inspect artwork');
      var enlarged = svg.cloneNode(true);
      enlarged.querySelector('clipPath').id = 'bb-upload-placement-detail-clip';
      enlarged.querySelector('g').setAttribute('clip-path', 'url(#bb-upload-placement-detail-clip)');
      detail.appendChild(enlarged);
      figure.appendChild(detail);
      // Start at the artwork's centred placement, not an empty strip end.
      doc.defaultView.requestAnimationFrame && doc.defaultView.requestAnimationFrame(function () {
        detail.scrollLeft = (detail.scrollWidth - detail.clientWidth) / 2;
      });
    }
    var caption = doc.createElement("figcaption");
    caption.textContent = "Placement preview · " + template.label;
    figure.appendChild(caption);
    var note = doc.createElement("p");
    note.className = "bb-review__placement-note";
    note.textContent = "Approximate preview—not a print proof." + (template.strip ? ' Scroll the enlarged strip to inspect. Hardware and reverse side are not shown.' : ' Single-face view; front/back sheets are not separated.');
    figure.appendChild(note);
    var warning = doc.createElement("p");
    warning.className = "bb-review__placement-note";
    warning.setAttribute("data-bb-placement-warning", "");
    warning.setAttribute("role", "status");
    warning.hidden = true;
    figure.appendChild(warning);
    var badge = original.closest(".bb-review__badge") || original;
    badge.before(figure);
    badge.hidden = true;
    var lead = review.querySelector(".bb-review__lead");
    var leadText = lead && lead.textContent;
    if (lead) lead.textContent = "Check how your artwork fits the " + template.noun + ". Your original file is unchanged; preview placement is not saved.";
    var checklist = review.querySelector(".bb-review__checklist");
    var checklistHidden = checklist && checklist.hidden;
    if (checklist) checklist.hidden = true;
    var approval = review.querySelector("[data-bb-design-review-approve]");
    var approvalLabel = approval && approval.closest("label");
    var approvalCopy = approvalLabel && approvalLabel.querySelector("span");
    var approvalText = approvalCopy && approvalCopy.textContent;
    if (approvalCopy) approvalCopy.textContent = "I understand this is a placement test. Submit my original file unchanged.";
    function loaded() {
      var mismatch = original.naturalWidth && original.naturalHeight &&
        Math.abs((original.naturalWidth / original.naturalHeight) / (w / h) - 1) > 0.0225;
      warning.hidden = !mismatch;
      warning.textContent = mismatch
        ? "Your image proportions differ from this " + (template.strip ? 'strip' : 'badge') + ". Check the white space shown, or choose Change file to replace your image."
        : "";
    }
    function failed() {
      figure.hidden = true;
      badge.hidden = false;
      if (lead) lead.textContent = "Placement preview unavailable. Your original file is unchanged. Use Change file to try another PNG or JPEG.";
    }
    original.addEventListener("load", loaded);
    original.addEventListener("error", failed);
    if (original.complete) loaded();
    return function () {
      original.removeEventListener("load", loaded);
      original.removeEventListener("error", failed);
      figure.remove();
      badge.hidden = false;
      if (lead) lead.textContent = leadText;
      if (checklist) checklist.hidden = checklistHidden;
      if (approvalCopy) approvalCopy.textContent = approvalText;
    };
  }

  function setPromptBusy(button, busy) {
    if (!button) return;
    button.classList.add("bb-prompt-busy");
    button.disabled = busy;
    if (busy) button.setAttribute("aria-busy", "true");
    else button.removeAttribute("aria-busy");
  }

  function stableValue(value) {
    if (Array.isArray(value)) return value.map(stableValue);
    if (!value || typeof value !== "object") return value;
    return Object.keys(value)
      .sort()
      .reduce(function (result, key) {
        result[key] = stableValue(value[key]);
        return result;
      }, {});
  }

  function numericId(value) {
    var match = String(value == null ? "" : value).match(/(\d+)$/);
    return match ? Number(match[1]) : null;
  }

  function selectionFingerprint(selection) {
    selection = selection || {};
    return JSON.stringify(
      stableValue({
        productId: numericId(selection.productId),
        variantId: numericId(selection.variantId),
        configuration:
          selection.configuration && typeof selection.configuration === "object"
            ? selection.configuration
            : String(selection.configuration || ""),
        quantity: Number(selection.quantity) || 0,
        deliveryDate: String(selection.deliveryDate || ""),
        offer: String(selection.offer || ""),
        printingMethod: String(selection.printingMethod || ""),
        properties: selection.properties || {},
      }),
    );
  }

  function manualArtworkProperties(upload, file) {
    var properties = {
      "Uploaded Design": upload.original_name || file.name,
      "_BadgeBuzz artwork upload id": upload.file_id,
      _bb_artwork_source: "manual_upload",
    };
    if (upload.preview_url)
      properties["_BadgeBuzz artwork preview"] = upload.preview_url;
    return properties;
  }

  function zakekeArtworkProperties(input) {
    input = input || {};
    var previews = Array.isArray(input.previews)
      ? input.previews.filter(Boolean)
      : [];
    var properties = {
      _zakeke_design_id: String(input.designId || ""),
      _zakeke_owner_type: input.customerId ? "customer" : "guest",
    };
    if (input.customerId)
      properties._zakeke_customer_id = String(input.customerId);
    else if (input.visitorCode)
      properties._zakeke_visitor_code = String(input.visitorCode);
    if (previews[0]) {
      properties._zakeke_preview_image = previews[0];
      properties["Design Preview"] = previews[0];
    }
    if (previews[1]) {
      properties._zakeke_preview_image_back = previews[1];
      properties["Design Preview Back"] = previews[1];
    }
    return properties;
  }

  function persistSavedDesignLabel(win, controller, selection, designId) {
    if (
      !designId ||
      !win.BBSavedDesignLabels ||
      typeof win.BBSavedDesignLabels.persist !== "function"
    ) {
      return Promise.resolve(false);
    }
    try {
      return Promise.resolve(
        win.BBSavedDesignLabels.persist({
          designId: String(designId),
          productTitle:
            (controller.product && controller.product.title) || "Saved design",
          configuration:
            selection && selection.configuration
              ? selection.configuration
              : {},
        }),
      );
    } catch (error) {
      return Promise.resolve(false);
    }
  }

  function savedProjectsUrl(win) {
    var destination = "/pages/account";
    try {
      var previewThemeId = new win.URL(win.location.href).searchParams.get(
        "preview_theme_id",
      );
      if (previewThemeId)
        destination +=
          "?preview_theme_id=" + encodeURIComponent(previewThemeId);
    } catch (error) {}
    return destination + "#projects";
  }

  function ownerWindow(node) {
    return (
      (node && node.ownerDocument && node.ownerDocument.defaultView) || window
    );
  }

  function routeRoot(win) {
    return (
      (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || "/"
    );
  }

  function getVisitorCode(win) {
    var generated = Math.random().toString(36).slice(2);
    try {
      win.localStorage.zakekeGuest = win.localStorage.zakekeGuest || generated;
      return win.localStorage.zakekeGuest;
    } catch (error) {
      return generated;
    }
  }

  function normalizePreviews(message) {
    var source =
      message &&
      (message.previews ||
        message.Previews ||
        (message.data && (message.data.previews || message.data.previewFiles)));
    return (Array.isArray(source) ? source : [])
      .map(function (item) {
        return typeof item === "string"
          ? item
          : item &&
              (item.url || item.previewUrl || item.preview_url || item.path);
      })
      .filter(Boolean);
  }

  function appendProperties(formData, properties) {
    Object.keys(properties || {}).forEach(function (name) {
      var value = properties[name];
      if (value == null || value === "") return;
      formData.append("properties[" + name + "]", value);
    });
  }

  function requireSelection(controller) {
    var selection = controller.selection();
    if (
      !selection ||
      selection.ready === false ||
      !numericId(selection.productId || controller.product.id) ||
      !numericId(selection.variantId) ||
      !Number.isSafeInteger(Number(selection.quantity)) ||
      Number(selection.quantity) < 1
    ) {
      throw new Error(
        "Complete the product options and choose a quantity first.",
      );
    }
    selection = Object.assign({}, selection, {
      productId: selection.productId || controller.product.id,
    });
    return selection;
  }

  function showToast(win, title, message, variant) {
    if (win.BBToast && typeof win.BBToast.show === "function") {
      win.BBToast.show({
        variant: variant || "success",
        title: title,
        message: message || "",
      });
    }
  }

  function refreshCart(win, trigger) {
    if (typeof win.bbRefreshAndOpenCartDrawer === "function") {
      return Promise.resolve(win.bbRefreshAndOpenCartDrawer(trigger)).then(
        function () {
          return true;
        },
      );
    }
    win.document.dispatchEvent(
      new win.CustomEvent("cart:updated", {
        detail: { source: "product-design" },
      }),
    );
    return Promise.resolve(false);
  }

  function runtimeFor(runtimeRoot) {
    if (!runtimeRoot)
      throw new Error("The product design runtime is unavailable.");
    if (runtimeRoot.bbProductDesignRuntime)
      return runtimeRoot.bbProductDesignRuntime;
    var win = ownerWindow(runtimeRoot);
    var modal = runtimeRoot.querySelector("[data-bb-design-modal]");
    var iframe = runtimeRoot.querySelector("[data-bb-design-iframe]");
    var loading = runtimeRoot.querySelector("[data-bb-design-loading]");
    var error = runtimeRoot.querySelector("[data-bb-design-error]");
    var stage = runtimeRoot.querySelector("[data-bb-design-stage]");
    var review = runtimeRoot.querySelector("[data-bb-design-review]");
    var reviewImage = runtimeRoot.querySelector(
      "[data-bb-design-review-image]",
    );
    var reviewFile = runtimeRoot.querySelector("[data-bb-design-review-file]");
    var placementCleanup = null;
    var reviewContinue = runtimeRoot.querySelector(
      "[data-bb-design-review-continue]",
    );
    var reviewEdit = runtimeRoot.querySelector("[data-bb-design-review-edit]");
    var reviewError = runtimeRoot.querySelector("[data-bb-design-review-error]");
    if (!reviewError && reviewContinue) {
      reviewError = win.document.createElement("p");
      reviewError.className = "bb-review__error";
      reviewError.setAttribute("data-bb-design-review-error", "");
      reviewError.setAttribute("role", "alert");
      reviewError.setAttribute("aria-atomic", "true");
      reviewError.hidden = true;
      reviewContinue.before(reviewError);
    }
    var reviewToggle = runtimeRoot.querySelector(
      "[data-bb-design-review-toggle]",
    );
    var close = modal && modal.querySelector("[data-bb-design-modal-close]");
    var retry = modal && modal.querySelector("[data-bb-design-retry]");
    var confirm = modal && modal.querySelector("[data-bb-design-confirm]");
    var confirmKeep =
      confirm && confirm.querySelector("[data-bb-design-confirm-keep]");
    var confirmDiscard =
      confirm && confirm.querySelector("[data-bb-design-confirm-discard]");
    var modalTitle =
      modal && modal.querySelector("[data-bb-design-modal-title]");
    var active = null;
    var pendingReview = null;
    var lastPreviews = [];
    var loadTimer = null;
    var loadingCopyTimer = null;
    var iframeDocumentLoaded = false;
    var designerLoadFailed = false;
    var designerReady = false;
    var revealGeneration = 0;
    var revealTimer = null;
    var lastFocus = null;
    var bodyOverflowBeforeOpen = "";
    var openedAt = 0;
    var hasStartedDesign = false;
    var lastSavedProjectToastAt = 0;
    var savedProjectSnapshot = null;
    var savedProjectSnapshotPromise = null;
    var savedProjectPollTimer = null;
    var savedProjectPollStartedAt = 0;
    var savedProjectToastShown = false;
    var tokenCache = null;
    var references = 0;
    var toggleBindings = [];

    var LOADING_COPY_STEPS = [
      {
        title: "Setting up your designer",
        subtitle: "Loading your product and design tools.",
        duration: 4200,
      },
      {
        title: "Preparing your product",
        subtitle: "Applying your selected options.",
        duration: 4400,
      },
      {
        title: "Getting the canvas ready",
        subtitle: "Loading fonts, colors, and design controls.",
        duration: 4500,
      },
      {
        title: "Almost there…",
        subtitle: "Your designer will be ready in a moment.",
        duration: 0,
      },
    ];

    function stopLoadingCopySequence() {
      if (loadingCopyTimer) win.clearTimeout(loadingCopyTimer);
      loadingCopyTimer = null;
    }

    function startLoadingCopySequence() {
      stopLoadingCopySequence();
      var copy = loading && loading.querySelector("[data-bb-loading-copy]");
      var title = loading && loading.querySelector("[data-bb-loading-title]");
      var subtitle =
        loading && loading.querySelector("[data-bb-loading-subtitle]");
      if (!copy || !title || !subtitle) return;
      var stepIndex = 0;
      copy.classList.remove("is-changing");
      title.textContent = LOADING_COPY_STEPS[0].title;
      subtitle.textContent = LOADING_COPY_STEPS[0].subtitle;

      function queueNextStep() {
        if (stepIndex >= LOADING_COPY_STEPS.length - 1) return;
        loadingCopyTimer = win.setTimeout(function () {
          copy.classList.add("is-changing");
          loadingCopyTimer = win.setTimeout(function () {
            stepIndex += 1;
            title.textContent = LOADING_COPY_STEPS[stepIndex].title;
            subtitle.textContent = LOADING_COPY_STEPS[stepIndex].subtitle;
            copy.classList.remove("is-changing");
            queueNextStep();
          }, 180);
        }, LOADING_COPY_STEPS[stepIndex].duration);
      }

      queueNextStep();
    }

    /* Keep the viewport overlays out of product-section stacking contexts,
       matching the standalone product-page runtime. */
    if (modal && modal.parentNode !== win.document.body)
      win.document.body.appendChild(modal);
    if (review && review.parentNode !== win.document.body)
      win.document.body.appendChild(review);

    function modalIsOpen() {
      return Boolean(modal && modal.classList.contains("open"));
    }

    function reviewIsOpen() {
      return Boolean(review && review.classList.contains("open"));
    }

    function lockPage() {
      if (!modalIsOpen() && !reviewIsOpen()) {
        var cartEditor = win.document.querySelector('#bb-zakeke-edit-modal.open');
        bodyOverflowBeforeOpen = cartEditor
          ? cartEditor._bbPreviousBodyOverflow || ''
          : win.document.body.style.overflow;
      }
      win.document.documentElement.classList.add("bb-zakeke-open");
      win.document.body.style.overflow = "hidden";
    }

    function unlockPageIfIdle() {
      if (modalIsOpen() || reviewIsOpen() || win.document.querySelector('#bb-zakeke-edit-modal.open')) return;
      win.document.documentElement.classList.remove("bb-zakeke-open");
      win.document.body.style.overflow = bodyOverflowBeforeOpen;
      bodyOverflowBeforeOpen = "";
    }

    function cancelDesignerHandoff() {
      revealGeneration += 1;
      if (revealTimer) win.clearTimeout(revealTimer);
      revealTimer = null;
      if (loading) loading.classList.remove("is-leaving");
      if (iframe) iframe.style.visibility = "hidden";
    }

    function beginDesignerHandoff() {
      if (!iframe || !loading) return;
      stopLoadingCopySequence();
      if (revealTimer) win.clearTimeout(revealTimer);
      var handoffGeneration = ++revealGeneration;
      loading.classList.remove("is-leaving");
      iframe.style.visibility = "visible";
      win.requestAnimationFrame(function () {
        win.requestAnimationFrame(function () {
          if (
            handoffGeneration !== revealGeneration ||
            !designerReady ||
            !active ||
            !modal ||
            !modal.classList.contains("open") ||
            iframe.src === "about:blank"
          ) {
            if (handoffGeneration === revealGeneration)
              iframe.style.visibility = "hidden";
            return;
          }
          revealTimer = win.setTimeout(function () {
            if (
              handoffGeneration !== revealGeneration ||
              !designerReady ||
              !active ||
              !modal.classList.contains("open") ||
              iframe.src === "about:blank"
            ) {
              if (handoffGeneration === revealGeneration)
                iframe.style.visibility = "hidden";
              return;
            }
            loading.classList.add("is-leaving");
            revealTimer = win.setTimeout(function () {
              if (
                handoffGeneration !== revealGeneration ||
                !designerReady ||
                !active ||
                !modal.classList.contains("open") ||
                iframe.src === "about:blank"
              ) {
                if (handoffGeneration === revealGeneration)
                  iframe.style.visibility = "hidden";
                return;
              }
              loading.style.display = "none";
              loading.classList.remove("is-leaving");
              revealTimer = null;
              if (stage) stage.setAttribute("aria-busy", "false");
            }, 220);
          }, 160);
        });
      });
    }

    function closeModal() {
      if (loadTimer) win.clearTimeout(loadTimer);
      stopLoadingCopySequence();
      cancelDesignerHandoff();
      if (modal) modal.classList.remove("open");
      if (modal) modal.hidden = true;
      if (confirm) confirm.classList.remove("open");
      if (iframe) iframe.src = "about:blank";
      iframeDocumentLoaded = false;
      designerLoadFailed = false;
      designerReady = false;
      hasStartedDesign = false;
      openedAt = 0;
      active = null;
      stopSavedProjectPolling();
      unlockPageIfIdle();
      if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
      lastFocus = null;
    }

    function requestClose() {
      if (hasStartedDesign && confirm) {
        confirm.classList.add("open");
        if (confirmKeep && typeof confirmKeep.focus === "function")
          confirmKeep.focus();
        return;
      }
      closeModal();
    }

    function keepEditing() {
      if (confirm) confirm.classList.remove("open");
      if (close && typeof close.focus === "function") close.focus();
    }

    function showSavedDesignToast() {
      if (
        !win.zakekeCustomerId ||
        !win.BBToast ||
        typeof win.BBToast.show !== "function" ||
        win.Date.now() - lastSavedProjectToastAt < 6000
      ) {
        return;
      }
      savedProjectToastShown = true;
      lastSavedProjectToastAt = win.Date.now();
      win.BBToast.show({
        variant: "success",
        title:
          runtimeRoot.dataset.bbSavedDesignTitle || "Design saved",
        message:
          runtimeRoot.dataset.bbSavedDesignMessage ||
          "You can find it anytime in My Projects.",
        action: {
          label:
            runtimeRoot.dataset.bbSavedDesignLink || "View My Projects",
          href: savedProjectsUrl(win),
          openInNewTab: true,
        },
        duration: 8000,
        dedupeKey: "saved-design",
      });
    }

    function getSavedProjectSnapshot() {
      if (!win.zakekeCustomerId) return Promise.resolve({});
      return win
        .fetch("/apps/bb-portal/projects", {
          headers: { Accept: "application/json" },
        })
        .then(function (response) {
          if (!response.ok) throw new Error("Projects request failed.");
          return response.json();
        })
        .then(function (data) {
          var snapshot = {};
          (data && Array.isArray(data.designs) ? data.designs : []).forEach(
            function (project) {
              var designId = String(project.designId || "");
              if (!designId) return;
              snapshot[designId] = [
                project.name || "",
                project.previewUrl || "",
                project.productUrl || "",
              ].join("|");
            },
          );
          return snapshot;
        });
    }

    function primeSavedProjectSnapshot() {
      savedProjectSnapshot = null;
      savedProjectSnapshotPromise = null;
      savedProjectToastShown = false;
      savedProjectPollStartedAt = 0;
      if (!win.zakekeCustomerId) return Promise.resolve({});
      savedProjectSnapshotPromise = getSavedProjectSnapshot()
        .then(function (snapshot) {
          savedProjectSnapshot = snapshot;
          return snapshot;
        })
        .catch(function () {
          savedProjectSnapshot = {};
          return savedProjectSnapshot;
        });
      return savedProjectSnapshotPromise;
    }

    function stopSavedProjectPolling() {
      if (savedProjectPollTimer) win.clearTimeout(savedProjectPollTimer);
      savedProjectPollTimer = null;
      savedProjectPollStartedAt = 0;
      savedProjectSnapshotPromise = null;
    }

    function scheduleSavedProjectPoll() {
      if (
        !win.zakekeCustomerId ||
        savedProjectToastShown ||
        savedProjectPollTimer
      )
        return;
      if (!savedProjectPollStartedAt)
        savedProjectPollStartedAt = win.Date.now();
      savedProjectPollTimer = win.setTimeout(function pollSavedProjects() {
        savedProjectPollTimer = null;
        if (!modalIsOpen() || savedProjectToastShown || !active) return;
        var baseline =
          savedProjectSnapshotPromise || Promise.resolve(savedProjectSnapshot);
        baseline
          .then(getSavedProjectSnapshot)
          .then(function (snapshot) {
            var previous = savedProjectSnapshot;
            savedProjectSnapshot = snapshot;
            if (previous === null) {
              if (win.Date.now() - savedProjectPollStartedAt < 120000)
                scheduleSavedProjectPoll();
              return;
            }
            var changedDesignId = Object.keys(snapshot).find(function (designId) {
              return (
                !Object.prototype.hasOwnProperty.call(previous, designId) ||
                previous[designId] !== snapshot[designId]
              );
            });
            if (changedDesignId) {
              persistSavedDesignLabel(
                win,
                active.controller,
                active.selection,
                changedDesignId,
              );
              showSavedDesignToast();
              stopSavedProjectPolling();
              return;
            }
            if (win.Date.now() - savedProjectPollStartedAt < 120000)
              scheduleSavedProjectPoll();
          })
          .catch(function () {
            if (win.Date.now() - savedProjectPollStartedAt < 120000)
              scheduleSavedProjectPoll();
          });
      }, 4500);
    }

    function onModalClick(event) {
      if (event.target === modal) requestClose();
    }

    function closeReview() {
      if (placementCleanup) placementCleanup();
      placementCleanup = null;
      if (review) review.classList.remove("open");
      if (review) review.hidden = true;
      pendingReview = null;
      unlockPageIfIdle();
    }

    function openReview(options) {
      if (!reviewApprovals) {
        reviewApprovals = (ReviewApprovals || win.BadgeBuzzReviewApprovals).mount(review, onReviewApprove);
      }
      if (placementCleanup) placementCleanup();
      placementCleanup = null;
      pendingReview = options;
      options.busy = false;
      if (reviewError) {
        reviewError.textContent = "";
        reviewError.hidden = true;
      }
      var previews = options.previews || [];
      if (reviewImage) {
        reviewImage.hidden = previews.length === 0;
        reviewImage.src = previews[0] || "";
      }
      if (reviewFile) {
        reviewFile.hidden = previews.length > 0;
        reviewFile.textContent = options.fileName
          ? "Uploaded: " + options.fileName
          : "Preview not available";
      }
      reviewApprovals.reset(options);
      if (options.placementPreview && previews[0] && reviewImage) {
        placementCleanup = showPlacementPreview(review, reviewImage, previews[0], options.placementPreview);
      }
      if (reviewToggle) {
        reviewToggle.hidden = previews.length < 2;
        reviewToggle.style.display = previews.length > 1 ? "flex" : "none";
        reviewToggle.querySelectorAll('[data-side]').forEach(function (button) {
          button.classList.toggle('active', button.dataset.side === 'front');
        });
      }
      if (reviewContinue) {
        setPromptBusy(reviewContinue, false);
        reviewContinue.disabled = true;
        reviewContinue.textContent = options.continueLabel || "Approve and continue";
      }
      if (reviewEdit) {
        reviewEdit.disabled = false;
        reviewEdit.textContent = options.editLabel || "Edit design";
      }
      lockPage();
      review.hidden = false;
      review.classList.add("open");
      return new Promise(function (resolve, reject) {
        options.resolve = resolve;
        options.reject = reject;
      });
    }

    function onReviewApprove() {
      if (reviewContinue)
        reviewContinue.disabled = !reviewApprovals.approved() || Boolean(pendingReview && pendingReview.busy);
    }
    function onReviewContinue() {
      if (!pendingReview || pendingReview.busy || reviewContinue.disabled || !reviewApprovals.approved()) return;
      var current = pendingReview;
      current.busy = true;
      if (reviewError) {
        reviewError.textContent = "";
        reviewError.hidden = true;
      }
      setPromptBusy(reviewContinue, true);
      reviewContinue.textContent = current.progressLabel || "Adding…";
      if (reviewEdit) reviewEdit.disabled = true;
      Promise.resolve()
        .then(current.commit)
        .then(function (value) {
          closeReview();
          current.resolve(value);
        })
        .catch(function (cause) {
          if (pendingReview !== current) return;
          current.busy = false;
          setPromptBusy(reviewContinue, false);
          onReviewApprove();
          reviewContinue.textContent = current.continueLabel || "Approve and continue";
          if (reviewEdit) reviewEdit.disabled = false;
          var message = cause && cause.message ? cause.message : "Please try again.";
          if (/artwork did not pass (security )?validation/i.test(message)) {
            message = "We couldn't verify this file. Make sure its extension matches its actual format (for example, a PNG should end in .png), then use Change file to upload it again.";
          } else if (/failed to fetch|network|timed? ?out/i.test(message)) {
            message = "We couldn't finish uploading your design. Check your connection, then try again.";
          }
          if (reviewError) {
            reviewError.textContent = message;
            reviewError.hidden = false;
            if (typeof reviewError.scrollIntoView === "function")
              reviewError.scrollIntoView({block: "nearest"});
          }
          // Keep this review's promise pending so retry/change-file can complete it.
        });
    }
    function onReviewEdit() {
      if (!pendingReview || pendingReview.busy) return;
      var current = pendingReview;
      closeReview();
      if (typeof current.onEdit === "function") current.onEdit();
      current.resolve(null);
    }
    var reviewApprovals = null;
    if (reviewContinue)
      reviewContinue.addEventListener("click", onReviewContinue);
    if (reviewEdit) reviewEdit.addEventListener("click", onReviewEdit);
    if (review)
      review
        .querySelectorAll("[data-bb-design-review-toggle] [data-side]")
        .forEach(function (button) {
          var handler = function () {
            if (!pendingReview || !reviewImage) return;
            var index = button.dataset.side === "back" ? 1 : 0;
            reviewImage.src = (pendingReview.previews || [])[index] || "";
            button.parentElement
              .querySelectorAll("[data-side]")
              .forEach(function (peer) {
                peer.classList.toggle("active", peer === button);
              });
          };
          toggleBindings.push({ button: button, handler: handler });
          button.addEventListener("click", handler);
        });

    function iframeUrl(controller, selection, token, designId) {
      var attributes = {};
      var productOptions = Array.isArray(controller.product.productOptions)
        ? controller.product.productOptions
        : [];
      var map = controller.product.zakekeAttributeMap;
      if (!map || typeof map !== "object") {
        map =
          productOptions.indexOf("Width") !== -1
            ? { Width: "1" }
            : { Size: "1" };
      }
      var configured =
        selection.configuration && typeof selection.configuration === "object"
          ? selection.configuration
          : selection.properties || {};
      Object.keys(configured).forEach(function (name) {
        if (
          map[name] &&
          (!productOptions.length || productOptions.indexOf(name) !== -1)
        )
          attributes[map[name]] = configured[name];
      });
      var body = {
        tokenoauth: token,
        productid: String(controller.product.id),
        name: controller.product.title,
        quantity: Number(selection.quantity),
        currency:
          (win.Shopify &&
            win.Shopify.currency &&
            win.Shopify.currency.active) ||
          "USD",
        culture: (win.Shopify && win.Shopify.locale) || "en",
        attributes: attributes,
        isClientPreviewsEnabled: true,
        canSaveDesign: true,
        hidevariants: true,
      };
      if (designId) body.designid = String(designId);
      return win
        .fetch(CUSTOMIZER_ENDPOINT, {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: "bearer " + token,
          },
          body: JSON.stringify(body),
        })
        .then(function (response) {
          if (!response.ok)
            throw new Error("Zakeke iframe API error: " + response.status);
          return response.json();
        })
        .then(function (data) {
          if (!data || !data.url)
            throw new Error("No URL returned from Zakeke.");
          var url = new win.URL(data.url, win.location.href);
          url.searchParams.set("ecommerce", "custom");
          url.searchParams.set("useProxyDesigns", "true");
          url.searchParams.set("isHeadless", "true");
          url.searchParams.set(
            "shareUrlPrefix",
            win.location.href.split("?")[0],
          );
          url.searchParams.set(
            win.zakekeCustomerId ? "c" : "v",
            win.zakekeCustomerId || getVisitorCode(win),
          );
          if (designId) url.searchParams.set("design", designId);
          var intentApi = win.BadgeBuzzZakekeLaunchIntent;
          return intentApi &&
            typeof intentApi.applyPrintingMethod === "function"
            ? intentApi.applyPrintingMethod(
                url.toString(),
                selection.printingMethod,
              )
            : url.toString();
        });
    }

    function fetchToken() {
      var tokenUrl = TOKEN_ENDPOINT;
      if (!win.zakekeCustomerId)
        tokenUrl += "?visitorCode=" + encodeURIComponent(getVisitorCode(win));
      return win
        .fetch(tokenUrl)
        .then(function (response) {
          if (!response.ok) throw new Error("Could not authenticate the designer.");
          return response.json();
        })
        .then(function (data) {
          if (!data.token) throw new Error("No Zakeke token returned.");
          return data.token;
        });
    }

    function warmToken() {
      if (tokenCache && win.Date.now() - tokenCache.ts < 60000)
        return tokenCache.promise;
      tokenCache = {
        ts: win.Date.now(),
        promise: fetchToken().catch(function (cause) {
          tokenCache = null;
          throw cause;
        }),
      };
      return tokenCache.promise;
    }

    function loadDesigner(controller, selection, designId) {
      cancelDesignerHandoff();
      active = {
        controller: controller,
        selection: selection,
        designId: designId || null,
      };
      lockPage();
      iframeDocumentLoaded = false;
      designerLoadFailed = false;
      designerReady = false;
      hasStartedDesign = false;
      openedAt = win.Date.now();
      lastSavedProjectToastAt = 0;
      lastPreviews = [];
      lastFocus = win.document.activeElement;
      if (modal) {
        modal.hidden = false;
        modal.classList.add("open");
      }
      if (loading) loading.style.display = "flex";
      startLoadingCopySequence();
      if (error) error.style.display = "none";
      if (stage) stage.setAttribute("aria-busy", "true");
      if (iframe) {
        iframe.style.visibility = "hidden";
        iframe.src = "about:blank";
      }
      if (modalTitle)
        modalTitle.textContent =
          "Customize " + (controller.product.title || "your product");
      var fallback = modal && modal.querySelector("[data-bb-design-fallback]");
      if (fallback)
        fallback.href =
          "/apps/zakeke?pid=" +
          encodeURIComponent(numericId(controller.product.id) || "");
      if (close && typeof close.focus === "function") close.focus();
      primeSavedProjectSnapshot().then(function () {
        if (modalIsOpen()) scheduleSavedProjectPoll();
      });
      if (loadTimer) win.clearTimeout(loadTimer);
      loadTimer = win.setTimeout(function () {
        if (iframeDocumentLoaded && !designerLoadFailed && modalIsOpen()) {
          designerReady = true;
          beginDesignerHandoff();
          console.log(
            "[BadgeBuzz] Zakeke boot signal timed out; revealing the loaded designer iframe.",
          );
          return;
        }
        designerLoadFailed = true;
        stopLoadingCopySequence();
        cancelDesignerHandoff();
        if (loading) loading.style.display = "none";
        if (error) error.style.display = "flex";
        if (stage) stage.setAttribute("aria-busy", "false");
      }, 30000);
      return Promise.resolve(warmToken())
        .then(function (token) {
          return iframeUrl(controller, selection, token, designId);
        })
        .then(function (url) {
          iframe.src = url;
        })
        .catch(function (cause) {
          designerLoadFailed = true;
          stopLoadingCopySequence();
          cancelDesignerHandoff();
          if (loading) loading.style.display = "none";
          if (error) error.style.display = "flex";
          throw cause;
        });
    }

    function onIframeLoad() {
      if (
        iframe.src === "about:blank" ||
        !modal ||
        !modal.classList.contains("open")
      )
        return;
      iframeDocumentLoaded = true;
    }
    function onMessage(event) {
      if (
        !active ||
        !iframe ||
        IFRAME_ORIGINS.indexOf(event.origin) === -1 ||
        event.source !== iframe.contentWindow
      )
        return;
      var message = event.data || {};
      if (message.zakekeType === "boot-completed") {
        iframeDocumentLoaded = true;
        designerLoadFailed = false;
        designerReady = true;
        if (loadTimer) win.clearTimeout(loadTimer);
        beginDesignerHandoff();
        console.log("[BadgeBuzz] Zakeke designer finished booting.");
      }
      if (
        message.zakekeMessageType === MSG_DESIGN_CHANGE &&
        win.Date.now() - openedAt > 2000
      ) {
        hasStartedDesign = true;
      }
      if (message.zakekeMessageType === MSG_SAVE_DESIGN) {
        var savedDesignId =
          message.designId ||
          message.designID ||
          message.compositionId ||
          (message.data &&
            (message.data.designId ||
              message.data.designID ||
              message.data.compositionId)) ||
          active.designId;
        persistSavedDesignLabel(
          win,
          active.controller,
          active.selection,
          savedDesignId,
        );
        if (typeof active.controller.onSaveDesign === "function") {
          Promise.resolve(
            active.controller.onSaveDesign({
              designId: savedDesignId,
              message: message,
              selection: active.selection,
            }),
          ).catch(function (cause) {
            showToast(
              win,
              "Couldn't save this design",
              cause.message || "Please try again.",
              "error",
            );
          });
        } else {
          showSavedDesignToast();
        }
      }
      var previews = normalizePreviews(message);
      if (previews.length) lastPreviews = previews;
      if (
        !designerReady ||
        MSG_ADD_TO_CART.indexOf(message.zakekeMessageType) === -1
      )
        return;
      var designId =
        message.designId ||
        message.designID ||
        message.compositionId ||
        active.designId;
      var context = active;
      var selectedPreviews = previews.length ? previews : lastPreviews;
      persistSavedDesignLabel(
        win,
        context.controller,
        context.selection,
        designId,
      );
      openReview({
        previews: selectedPreviews,
        progressLabel:
          context.controller.mode === "collect" ? "Saving…" : "Adding…",
        commit: function () {
          return context.controller
            .collectZakeke(
              designId,
              selectedPreviews,
              selectionFingerprint(context.selection),
            )
            .then(function (result) {
              closeModal();
              return result;
            });
        },
        onEdit: function () {
          loadDesigner(context.controller, context.selection, designId);
        },
      }).catch(function (cause) {
        showToast(
          win,
          "Couldn't save this design",
          cause.message || "Please try again.",
          "error",
        );
      });
    }

    function onKeydown(event) {
      if (event.key === "Tab") {
        var scope =
          review && review.classList.contains("open")
            ? review
            : confirm && confirm.classList.contains("open")
              ? confirm
              : modal && modal.classList.contains("open")
                ? modal
                : null;
        if (!scope) return;
        var focusable = Array.prototype.filter.call(
          scope.querySelectorAll(
            'a[href], button:not([disabled]), input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])',
          ),
          function (node) {
            return node.offsetParent !== null && !node.hidden;
          },
        );
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && win.document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && win.document.activeElement === last) {
          event.preventDefault();
          first.focus();
        } else if (!scope.contains(win.document.activeElement)) {
          event.preventDefault();
          first.focus();
        }
        return;
      }
      if (event.key === "Escape") {
        if (review && review.classList.contains("open")) onReviewEdit();
        else if (confirm && confirm.classList.contains("open")) keepEditing();
        else if (modal && modal.classList.contains("open")) requestClose();
      }
    }

    function onRetry() {
      if (active)
        loadDesigner(active.controller, active.selection, active.designId);
    }

    function destroyRuntime() {
      if (references > 0) return;
      if (pendingReview && typeof pendingReview.resolve === "function")
        pendingReview.resolve(null);
      closeReview();
      closeModal();
      if (iframe) iframe.removeEventListener("load", onIframeLoad);
      win.removeEventListener("message", onMessage);
      win.document.removeEventListener("keydown", onKeydown);
      if (close) close.removeEventListener("click", requestClose);
      if (retry) retry.removeEventListener("click", onRetry);
      if (modal) modal.removeEventListener("click", onModalClick);
      if (confirmKeep) confirmKeep.removeEventListener("click", keepEditing);
      if (confirmDiscard)
        confirmDiscard.removeEventListener("click", closeModal);
      if (reviewApprovals) reviewApprovals.destroy();
      if (reviewContinue)
        reviewContinue.removeEventListener("click", onReviewContinue);
      if (reviewEdit) reviewEdit.removeEventListener("click", onReviewEdit);
      toggleBindings.forEach(function (binding) {
        binding.button.removeEventListener("click", binding.handler);
      });
      if (modal) runtimeRoot.appendChild(modal);
      if (review) runtimeRoot.appendChild(review);
      delete runtimeRoot.bbProductDesignRuntime;
    }

    if (iframe) iframe.addEventListener("load", onIframeLoad);
    win.addEventListener("message", onMessage);
    win.document.addEventListener("keydown", onKeydown);
    if (close) close.addEventListener("click", requestClose);
    if (retry) retry.addEventListener("click", onRetry);
    if (modal) modal.addEventListener("click", onModalClick);
    if (confirmKeep) confirmKeep.addEventListener("click", keepEditing);
    if (confirmDiscard) confirmDiscard.addEventListener("click", closeModal);

    runtimeRoot.bbProductDesignRuntime = {
      openDesigner: loadDesigner,
      warmToken: warmToken,
      openReview: openReview,
      closeModal: closeModal,
      retain: function () {
        references += 1;
      },
      release: function () {
        references = Math.max(0, references - 1);
        destroyRuntime();
      },
    };
    return runtimeRoot.bbProductDesignRuntime;
  }

  function mount(options) {
    options = options || {};
    var root = options.root;
    var actionsRoot = options.actionsRoot;
    if (!root || !actionsRoot || typeof options.selection !== "function") {
      throw new Error(
        "A product root, action root, and selection callback are required.",
      );
    }
    var win = ownerWindow(root);
    var controller = {
      root: root,
      actionsRoot: actionsRoot,
      runtimeRoot:
        options.runtimeRoot ||
        win.document.querySelector("[data-bb-product-design-runtime]"),
      product: options.product || {},
      mode: options.mode === "collect" ? "collect" : "cart",
      selection: options.selection,
      onCollect:
        typeof options.onCollect === "function"
          ? options.onCollect
          : function () {},
      onCommitArtwork:
        typeof options.onCommitArtwork === "function"
          ? options.onCommitArtwork
          : null,
      onSaveDesign:
        typeof options.onSaveDesign === "function"
          ? options.onSaveDesign
          : null,
      beforeOpen:
        typeof options.beforeOpen === "function" ? options.beforeOpen : null,
      artwork: null,
      disconnected: false,
    };
    var runtime = runtimeFor(controller.runtimeRoot);
    runtime.retain();
    var designButton = actionsRoot.querySelector("[data-bb-open-zakeke]");
    var uploadButton = actionsRoot.querySelector(
      "[data-bb-upload-button], #bb-upload-btn",
    );
    var uploadInput = actionsRoot.querySelector(
      "[data-bb-upload-file], #bb-upload-file",
    );
    var uploadText = actionsRoot.querySelector(
      "[data-bb-upload-text], #bb-upload-text",
    );
    var designText =
      actionsRoot.querySelector("[data-bb-design-primary-text]") ||
      (designButton && designButton.querySelector("strong"));
    var designSubtext =
      actionsRoot.querySelector("[data-bb-design-primary-subtext]") ||
      (designButton &&
        designButton.querySelector(".bb-summary__cta-text span"));
    var productHeading = actionsRoot.querySelector(
      "[data-bb-design-product-heading]",
    );
    var status = actionsRoot.querySelector("[data-bb-design-status]");
    var statusTitle =
      status && status.querySelector("[data-bb-design-status-title]");
    var statusDetail =
      status && status.querySelector("[data-bb-design-status-detail]");

    if (
      controller.mode === "collect" &&
      productHeading &&
      controller.product &&
      controller.product.title
    ) {
      productHeading.textContent = "Artwork for " + controller.product.title;
      productHeading.hidden = false;
    }

    function renderActions() {
      if (controller.mode !== "collect") return;
      var source = controller.artwork && controller.artwork.source;
      if (designText)
        designText.textContent =
          source === "zakeke" ? "EDIT DESIGN" : "START DESIGNING";
      if (designSubtext) {
        designSubtext.textContent =
          source === "zakeke"
            ? "Continue editing your saved design"
            : "Choose one of our templates or start from scratch";
      }
      if (
        uploadText &&
        !(uploadButton && uploadButton.classList.contains("bb-uploading"))
      ) {
        uploadText.textContent =
          source === "manual_upload" ? "REPLACE UPLOAD" : "UPLOAD DESIGN";
      }
    }

    function renderStatus() {
      renderActions();
      if (status) {
        var ready = Boolean(controller.artwork);
        var source = ready && controller.artwork.source;
        var title = !ready
          ? "Design required"
          : source === "zakeke"
            ? "Design ready"
            : "Artwork uploaded";
        var detail = !ready
          ? "Create a design or upload your artwork."
          : source === "zakeke"
            ? "You can edit it anytime."
            : controller.artwork.label || "Artwork file";
        if (statusTitle && statusDetail) {
          statusTitle.textContent = title;
          statusDetail.textContent = detail;
        } else {
          status.textContent = ready ? title + ". " + detail : title;
        }
        status.dataset.bbDesignState = ready ? "ready" : "required";
        status.classList.remove("is-error");
        status.setAttribute("role", "status");
        status.hidden = !ready;
        actionsRoot.removeAttribute("data-bb-design-validation");
      }
    }

    controller.getArtwork = function () {
      return controller.artwork;
    };
    controller.setArtwork = function (artwork) {
      controller.artwork = artwork || null;
      renderStatus();
      return controller.artwork;
    };
    controller.invalidateIfStale = function () {
      if (!controller.artwork) return false;
      var selection;
      try {
        selection = requireSelection(controller);
      } catch (error) {
        selection = null;
      }
      if (
        !selection ||
        controller.artwork.fingerprint !== selectionFingerprint(selection)
      ) {
        controller.artwork = null;
        renderStatus();
        if (controller.mode === "collect") controller.onCollect(null);
        return true;
      }
      return false;
    };
    controller.commitArtwork = function (artwork) {
      var selection = requireSelection(controller);
      if (!artwork || artwork.fingerprint !== selectionFingerprint(selection)) {
        return Promise.reject(
          new Error("Your product options changed. Review the design again."),
        );
      }
      if (controller.mode === "collect") {
        controller.setArtwork(artwork);
        controller.onCollect(artwork);
        return Promise.resolve(artwork);
      }
      if (controller.onCommitArtwork) {
        return Promise.resolve(
          controller.onCommitArtwork(artwork, selection, controller),
        ).then(function (result) {
          controller.setArtwork(artwork);
          return result == null ? artwork : result;
        });
      }
      var formData = new win.FormData();
      formData.append("id", numericId(selection.variantId));
      formData.append("quantity", Number(selection.quantity));
      var selectionProperties = Object.assign({}, selection.properties || {});
      if (selection.deliveryDate)
        selectionProperties["Delivery date"] = selection.deliveryDate;
      if (selection.offer)
        selectionProperties["_BadgeBuzz offer"] = selection.offer;
      if (selection.configuration) {
        selectionProperties["_BadgeBuzz configuration"] =
          typeof selection.configuration === "string"
            ? selection.configuration
            : JSON.stringify(selection.configuration);
      }
      appendProperties(formData, selectionProperties);
      appendProperties(formData, artwork.properties || {});
      return win
        .fetch(routeRoot(win) + "cart/add.js", {
          method: "POST",
          body: formData,
        })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || (data.status && data.status >= 400))
              throw new Error(
                data.message || data.description || "Add to cart failed",
              );
            controller.setArtwork(artwork);
            return refreshCart(win, uploadButton || designButton).then(
              function (drawerOpened) {
                if (!drawerOpened) showToast(win, "Added to cart");
                return artwork;
              },
            );
          });
        });
    };
    controller.collectManualFile = function (file, expectedFingerprint) {
      var selection = requireSelection(controller);
      if (
        expectedFingerprint &&
        expectedFingerprint !== selectionFingerprint(selection)
      ) {
        return Promise.reject(
          new Error("Your product options changed. Review the file again."),
        );
      }
      if (
        !win.BBArtworkUpload ||
        typeof win.BBArtworkUpload.upload !== "function"
      ) {
        return Promise.reject(
          new Error("Secure artwork upload is unavailable."),
        );
      }
      return win.BBArtworkUpload.upload(file).then(function (upload) {
        return controller.commitArtwork({
          source: "manual_upload",
          fingerprint: selectionFingerprint(selection),
          properties: manualArtworkProperties(upload, file),
          previewUrls: upload.preview_url ? [upload.preview_url] : [],
          label: upload.original_name || file.name,
        });
      });
    };
    controller.collectZakeke = function (
      designId,
      previews,
      expectedFingerprint,
    ) {
      var selection = requireSelection(controller);
      if (
        expectedFingerprint &&
        expectedFingerprint !== selectionFingerprint(selection)
      ) {
        return Promise.reject(
          new Error("Your product options changed. Review the design again."),
        );
      }
      var properties = zakekeArtworkProperties({
        designId: designId,
        customerId: win.zakekeCustomerId || "",
        visitorCode: win.zakekeCustomerId ? "" : getVisitorCode(win),
        previews: previews,
      });
      persistSavedDesignLabel(win, controller, selection, designId);
      return controller.commitArtwork({
        source: "zakeke",
        fingerprint: selectionFingerprint(selection),
        properties: properties,
        previewUrls: Array.isArray(previews) ? previews.slice() : [],
        label: "Zakeke design " + designId,
      });
    };

    controller.openDesigner = function (designId) {
      var selected = requireSelection(controller);
      return Promise.resolve(
        controller.beforeOpen
          ? controller.beforeOpen({
              controller: controller,
              selection: selected,
              designId: designId || null,
            })
          : null,
      ).then(function () {
        return runtime.openDesigner(controller, selected, designId || null);
      });
    };
    controller.warmDesigner = function () {
      return runtime.warmToken();
    };

    function onDesignIntent() {
      controller.warmDesigner().catch(function () {});
    }

    function onDesign(event) {
      event.preventDefault();
      try {
        controller
          .openDesigner(
            controller.mode === "collect" &&
              controller.artwork &&
              controller.artwork.source === "zakeke" &&
              controller.artwork.properties
              ? controller.artwork.properties._zakeke_design_id
              : null,
          )
          .catch(function (cause) {
            showToast(
              win,
              "Couldn't load the customizer",
              cause.message || "Please try again.",
              "error",
            );
          });
      } catch (error) {
        showToast(win, "Review your product options", error.message, "warning");
      }
    }
    function onUpload(event) {
      event.preventDefault();
      try {
        requireSelection(controller);
      } catch (error) {
        showToast(win, "Review your product options", error.message, "warning");
        return;
      }
      uploadInput.click();
    }
    function onFile() {
      var file = uploadInput.files && uploadInput.files[0];
      if (!file) return;
      var selected;
      try {
        selected = requireSelection(controller);
      } catch (error) {
        showToast(win, "Review your product options", error.message, "warning");
        uploadInput.value = "";
        return;
      }
      var expectedFingerprint = selectionFingerprint(selected);
      var previewConfiguration = selected.configuration;
      if (typeof previewConfiguration === "string") {
        try { previewConfiguration = JSON.parse(previewConfiguration); }
        catch (error) { previewConfiguration = null; }
      }
      var pathHandle = win.location.pathname.match(/\/products\/([^/]+)\/?$/);
      var previewHandle = controller.product.handle || (pathHandle && pathHandle[1]) || '';
      var previewTemplate = placementTemplate(previewHandle, previewConfiguration, selected.properties);
      var previousUploadText = uploadText ? uploadText.textContent : "";
      var objectUrl = "";
      try {
        if (/^image\//.test(file.type || ""))
          objectUrl = win.URL.createObjectURL(file);
      } catch (error) {}
      if (uploadText) uploadText.textContent = "Uploading…";
      if (uploadButton) uploadButton.classList.add("bb-uploading");
      runtime
        .openReview({
          previews: objectUrl ? [objectUrl] : [],
          placementPreview: Boolean(objectUrl) &&
            /^(image\/png|image\/jpeg)$/.test(file.type || "") &&
            previewTemplate,
          fileName: file.name,
          editLabel: "Change file",
          progressLabel: controller.mode === "collect" ? "Saving…" : "Adding…",
          commit: function () {
            return controller.collectManualFile(file, expectedFingerprint);
          },
          onEdit: function () {
            uploadInput.value = "";
            uploadInput.click();
          },
        })
        .catch(function (cause) {
          showToast(win, "Couldn't upload your design", cause.message || "Please try again.", "error");
        })
        .finally(function () {
          if (objectUrl) win.URL.revokeObjectURL(objectUrl);
          if (uploadButton) uploadButton.classList.remove("bb-uploading");
          if (uploadText) uploadText.textContent = previousUploadText;
          renderActions();
          uploadInput.value = "";
        });
    }
    function onSelectionChange() {
      win.setTimeout(controller.invalidateIfStale, 0);
    }
    if (designButton) designButton.addEventListener("click", onDesign);
    if (designButton) {
      designButton.addEventListener("pointerenter", onDesignIntent);
      designButton.addEventListener("focusin", onDesignIntent);
      designButton.addEventListener("touchstart", onDesignIntent, {
        passive: true,
      });
    }
    if (uploadButton && uploadInput)
      uploadButton.addEventListener("click", onUpload);
    if (uploadInput) uploadInput.addEventListener("change", onFile);
    root.addEventListener("bb:product-controller-change", onSelectionChange);
    root.addEventListener("change", onSelectionChange);
    root.addEventListener("input", onSelectionChange);
    controller.disconnect = function () {
      controller.disconnected = true;
      if (designButton) designButton.removeEventListener("click", onDesign);
      if (designButton) {
        designButton.removeEventListener("pointerenter", onDesignIntent);
        designButton.removeEventListener("focusin", onDesignIntent);
        designButton.removeEventListener("touchstart", onDesignIntent);
      }
      if (uploadButton) uploadButton.removeEventListener("click", onUpload);
      if (uploadInput) uploadInput.removeEventListener("change", onFile);
      root.removeEventListener(
        "bb:product-controller-change",
        onSelectionChange,
      );
      root.removeEventListener("change", onSelectionChange);
      root.removeEventListener("input", onSelectionChange);
      runtime.release();
    };
    renderStatus();
    return controller;
  }

  return {
    mount: mount,
    selectionFingerprint: selectionFingerprint,
    manualArtworkProperties: manualArtworkProperties,
    zakekeArtworkProperties: zakekeArtworkProperties,
  };
});
